import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';

import { updateFormElementConfig, defaultElmentConfig } from '../Utils/FormComponentUtils';

const FormComponent = props => {
  const { formConfig } = props;
  const {
    fieldsConfig,
    isFormReadOnly,
    isFormValid: isDefaultFormValid,
    defaultValues: formDefaultValues,
    name,
  } = formConfig;

  const {
    control,
    formState: { isValid: isFormValid, isDirty, dirtyFields, touchedFields, defaultValues, errors },
    getValues,
    setValue,
    setError,
    clearErrors,
  } = useForm({
    mode: 'all',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
    shouldUnregister: true,
    defaultValues: formDefaultValues,
    isValid: isDefaultFormValid,
    name,
  });

  useEffect(() => {
    formConfig?.onFormChangeHandler?.({ ...formConfig, isFormValid });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFormValid]);

  return (
    <>
      {fieldsConfig?.map?.(config =>
        updateFormElementConfig(
          {
            ...formConfig,
            isFormReadOnly,
            isDirty,
            dirtyFields,
            touchedFields,
            defaultValues,
            errors,
            isFormValid,
            name,
            control,
            getValueFromElements: fieldName => getValues(fieldName),
            setValueToFormElements: (fieldName, fieldValue) => setValue(fieldName, fieldValue),
            setErrorToFormElements: (fieldName, errorType, errorMessage) =>
              setError(fieldName, { type: errorType, message: errorMessage }),
            clearErrorToFormElements: fieldName => clearErrors(fieldName),
          },
          {
            ...defaultElmentConfig,
            ...config,
          },
        ),
      )}
    </>
  );
};

FormComponent.propTypes = {
  formConfig: {
    fieldsConfig: PropTypes.object,
    isFormReadOnly: PropTypes.bool,
    isFormValid: PropTypes.bool,
    onFormChangeHandler: PropTypes.func,
    defaultValues: PropTypes.object,
    name: PropTypes.string,
  },
};

FormComponent.defaultProps = {
  formConfig: {
    fieldsConfig: [],
    isFormReadOnly: false,
    isFormValid: false,
    onFormChangeHandler: null,
    defaultValues: {},
    name: '',
  },
};

export default React.memo(FormComponent);
